export default [
    // 渠道管理列表
    {
        path: "managechannel/channelbase/list",
        name: "channelBase",
        component: () => import(/* webpackChunkName: "manage" */ "@/views/managechannel/managechannel/channelbase/index"),
    },
    {
        path: "managechannel/channelbase/list/update/:type",
        name: "channelUpdate",
        component: () => import(/* webpackChunkName: "manage" */ "@/views/managechannel/managechannel/channelbase/update"),
    },
    // 添加子账号
    {
        path: "managechannel/addchild/:type",
        name: "channelAddchild",
        component: () => import(/* webpackChunkName: "manage" */ "@/views/managechannel/managechannel/addchildamazon/addchild"),
    },
    // 添加vendors子账号
    {
        path: "managechannel/addchildvendor/:type",
        name: "channelAddchildVendor",
        component: () => import(/* webpackChunkName: "manage" */ "@/views/managechannel/managechannel/addchildvendor/update"),
    },
    // 渠道管理->编辑发运方式
    {
        path: "managechannel/channelbase/editchannel/:type",
        name: "manageEditChannel",
        component: () => import(/* webpackChunkName: "manage" */ "@/views/managechannel/managechannel/channelbase/editchannel"),
    },
    // 系统设置 平台发运方式管理
    {
        path: "system/platform/list",
        name: "platformlist",
        component: () => import(/* webpackChunkName: "manage" */ "@/views/managechannel/system/platform/index"),
    },
    {
        path: "system/platform/list/update/:type",
        name: "platformUpdate",
        component: () => import(/* webpackChunkName: "manage" */ "@/views/managechannel/system/platform/update"),
    },
    // 系统设置 仓库发运方式
    {
        path: "system/managewarehouse/list",
        name: "sysmanageware",
        component: () => import(/* webpackChunkName: "manage" */ "@/views/managechannel/system/managewarehouse/index"),
    },
    {
        path: "system/managewarehouse/list/update/:type",
        name: "sysWareUpdate",
        component: () => import(/* webpackChunkName: "manage" */ "@/views/managechannel/system/managewarehouse/update"),
    },
    // 批量管理发运方式
    {
        path: "system/managewarehouse/list/batchway/:type",
        name: "sysWareBatchway",
        component: () => import(/* webpackChunkName: "manage" */ "@/views/managechannel/system/managewarehouse/batchway"),
    },

    // 仓库发运方式管理
    {
        path: "managewarehouse/list",
        name: "managewarehouse",
        component: () => import(/* webpackChunkName: "manage" */ "@/views/managechannel/managewarehouse/index"),
    },
    {
        path: "managewarehouse/list/update/:type",
        name: "managewareUpdate",
        component: () => import(/* webpackChunkName: "manage" */ "@/views/managechannel/managewarehouse/update"),
    },
    // 渠道发货地址维护
    {
        path: "deliverychannel/list",
        name: "deliverychannelList",
        component: () => import(/* webpackChunkName: "manage" */ "@/views/managechannel/deliverychannel/index"),
    },
    {
        path: "deliverychannel/list/update/:type",
        name: "deliverychannelUpdate",
        component: () => import(/* webpackChunkName: "manage" */ "@/views/managechannel/deliverychannel/update"),
    },
    // 渠道协议
    {
        path: "managechannel/agreementList",
        name: "agreementList",
        component: () => import(/* webpackChunkName: "manage" */ "@/views/managechannel/agreement/index"),
    },
    {
        path: "managechannel/agreementUpdate/:type",
        name: "agreementUpdate",
        component: () => import(/* webpackChunkName: "manage" */ "@/views/managechannel/agreement/update"),
    },
] 